import React from 'react';
import { Section } from './Section';
import { Clock } from 'lucide-react';
export const Gancho = () => {
  return <Section className="relative" data-id="element-95">
      <div className="absolute left-1/2 -top-10 -translate-x-1/2 w-px h-20 bg-gradient-to-b from-transparent to-gold/50" data-id="element-96" />

      <div className="max-w-3xl mx-auto text-center" data-id="element-97">
        <div className="flex justify-center mb-8 text-gold/60" data-id="element-98">
          <Clock size={32} strokeWidth={1.5} data-id="element-99" />
        </div>

        <h2 className="text-3xl md:text-4xl font-serif text-gold mb-10 leading-tight" data-id="element-100">
          Son las 6:30 de la tarde. Acabás de cerrar la puerta del trabajo, pero
          sentís que pesás 100 kilos.
        </h2>

        <div className="space-y-6 text-lg text-gray-300 font-light leading-relaxed text-left md:text-center" data-id="element-101">
          <p data-id="element-102">
            No es cansancio físico; es esa nube gris de la oficina que se te
            pegó al cuerpo y no te deja disfrutar de tus hijos, de tu pareja o
            de tu propio silencio.
          </p>
          <p data-id="element-103">
            Entrás a tu casa y, aunque el día terminó, tu cabeza sigue librando
            batallas con ese comentario pasivo-agresivo de tu jefa o la queja
            interminable de tu compañera de escritorio.
          </p>
          <p className="text-xl font-medium text-offwhite mt-8 p-6 border border-gold/20 bg-navy-900/50 rounded-sm relative" data-id="element-104">
            <span className="absolute -top-3 left-6 bg-navy-800 px-2 text-gold text-sm tracking-widest uppercase" data-id="element-105">
              La Realidad
            </span>
            Estás presente físicamente, pero tu energía se quedó atrapada en el
            cubículo.
          </p>
        </div>
      </div>
    </Section>;
};